import React from 'react';

import { InventoryTabItemName } from '../../../../../InventoryStore';
import { useInventoryState, useReadOnlyRowConfig } from '../../../../../hooks';
import { isDateAfterEndOfSale, isDatePast } from '../../../../../utils';
import type { PackDetails } from '../../../../../utils/packs';
import { LabelValueCell } from '../../../../Table/Cells/LabelValueCell/LabelValueCell';
import { PureFieldCell } from '../../../../Table/Cells/PureFieldCell/PureFieldCell';

const PackRoomCatContentRowComponent: React.FC<{ packId: number }> = ({
  packId,
}) => {
  const { inventoryPacks, dateKeys } = useReadOnlyRowConfig(
    InventoryTabItemName.Packs
  );

  const { endOfSaleDate } = useInventoryState();

  if (!inventoryPacks) {
    return null;
  }

  return (
    <>
      {dateKeys.map((dateKey) => {
        const fieldName = [dateKey, `${packId}`];
        const isGrayed =
          isDatePast(dateKey) || isDateAfterEndOfSale(dateKey, endOfSaleDate);

        return (
          <PureFieldCell key={dateKey} name={fieldName} dateKey={dateKey}>
            {(values?: PackDetails) => {
              if (!values) {
                return null;
              }

              return (
                <LabelValueCell
                  value={`${values?.sellableCategoryCount ?? 0}/${
                    values?.totalCategoryCount ?? 0
                  }`}
                  date={dateKey}
                  name={''}
                  grayed={isGrayed}
                />
              );
            }}
          </PureFieldCell>
        );
      })}
    </>
  );
};

export const PackRoomCatContentRow = React.memo(PackRoomCatContentRowComponent);
